var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utilI18N.ts
import UtilTranslationApi from "@dia-ui/util_translation-api";
import { i18n } from "typesafe-i18n";
import sprintf from "@jitesoft/sprintf";
var _a, _b;
var _UtilI18N = class _UtilI18N {
  constructor() {
    /**
     * INSTANCE
     * @private
     */
    this.INSTANCE = void 0;
    /**
     * ASSET_PATH
     * @private
     */
    this.ASSET_PATH = "/";
    /**
     * DEFAULT_LANGUAGE
     * @private
     */
    this.DEFAULT_LANGUAGE = "de";
    /**
     * STORAGE_KEY
     * @private
     */
    this.STORAGE_KEY = "dia-i18n-language";
    /**
     * SYSTEM_ID
     * @private
     */
    this.SYSTEM_ID = typeof process !== "undefined" && ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.DIA_I18N_SYSTEM_ID) || _UtilI18N.ENVIRONMENT_DEFAULT.DIA_I18N_SYSTEM_ID;
    /**
     * MACHINE
     * @private
     */
    this.MACHINE = typeof process !== "undefined" && ((_b = process == null ? void 0 : process.env) == null ? void 0 : _b.DIA_I18N_MACHINE) || _UtilI18N.ENVIRONMENT_DEFAULT.DIA_I18N_MACHINE;
    /**
     * FALLBACK_CACHE
     * @private
     */
    this.FALLBACK_CACHE = false;
    /**
     * ATTRIBUTES
     * @private
     */
    this.ATTRIBUTES = {
      ELEMENT: "data-i18n-locale",
      DOCUMENT: "lang"
    };
  }
  /**
   * getInstance
   * @param locale
   * @param assetPath
   * @param useFallbackCache
   */
  initialize(locale, assetPath, useFallbackCache) {
    return __async(this, null, function* () {
      try {
        let localesResponse = yield fetch("/dia-i18n.json"), localesResponseJSON = yield localesResponse.json();
        this.LOCALES = (localesResponseJSON == null ? void 0 : localesResponseJSON.languages) || [];
      } catch (_error) {
        this.LOCALES = [
          "de",
          "fr",
          "en"
        ];
      }
      this.FALLBACK_CACHE = useFallbackCache;
      this.LOCALE = locale;
      if (assetPath) {
        this.ASSET_PATH = assetPath;
      }
      if (this.INSTANCE === void 0) {
        yield this.setLocale(locale, this.FALLBACK_CACHE);
      }
    });
  }
  /**
   * setLocale
   * @param locale
   * @param useFallbackCache
   */
  setLocale(locale, useFallbackCache) {
    return __async(this, null, function* () {
      if (locale === "gb") {
        locale = "en";
      }
      this.LOCALE = locale;
      localStorage.setItem(this.STORAGE_KEY, this.LOCALE);
      let localeResponse, localeResponseJSON, localeTranslationFilePath = this.ASSET_PATH + "translation-" + locale + ".json";
      this.MACHINE = window.location.host + localeTranslationFilePath;
      try {
        localeResponse = yield fetch(localeTranslationFilePath);
        localeResponseJSON = yield localeResponse.json();
      } catch (_error) {
        try {
          let translationApi = new UtilTranslationApi(
            this.MACHINE,
            this.SYSTEM_ID
          );
          if (useFallbackCache) {
            translationApi.useCache();
          }
          let translationsApiResponse = yield translationApi.fetchAll(locale);
          localeResponseJSON = {
            language: locale,
            entries: translationsApiResponse
          };
        } catch (__error) {
          if (locale !== this.DEFAULT_LANGUAGE) {
            return yield this.setLocale(this.DEFAULT_LANGUAGE);
          }
          console.error(
            "failed to load local '" + locale + "' from '" + localeTranslationFilePath + "' and fallback to translation server not working: " + __error
          );
          return;
        }
      }
      let translations = {};
      translations[localeResponseJSON.language] = localeResponseJSON.entries;
      this.INSTANCE = i18n(translations, {});
    });
  }
  /**
   * getLocale
   */
  getLocale() {
    return localStorage.getItem(this.STORAGE_KEY) || this.DEFAULT_LANGUAGE;
  }
  /**
   * getLocales
   */
  getLocales() {
    return this.LOCALES;
  }
  /**
   * isReady
   */
  isReady() {
    return !!this.INSTANCE;
  }
  /**
   * t
   * @param phrase
   * @param args
   */
  t(phrase, args) {
    if (this.INSTANCE === void 0) {
      console.error("please initialize the I18N interface!");
      return;
    }
    let translation = this.INSTANCE[this.LOCALE][phrase] || false, result;
    if (translation) {
      result = translation();
    }
    if (!result || result && result.trim().length === 0) {
      result = phrase + _UtilI18N.PHRASE_NOT_FOUND_SIGN;
    }
    if (args) {
      let _args = [result, ...args];
      result = sprintf.apply(this, _args);
    }
    return result;
  }
  /**
   * observeOwnerDocumentLocale
   * @param ownerDocument
   * @param baseElement
   * @param callback
   */
  observeOwnerDocumentLocale(ownerDocument, callback, baseElement) {
    let htmlElement = ownerDocument.getElementsByTagName("html")[0];
    const ownerDocumentObserver = new MutationObserver((mutations) => {
      if (baseElement && baseElement.hasAttribute(this.ATTRIBUTES.ELEMENT)) return;
      mutations.forEach((mutation) => __async(this, null, function* () {
        if (mutation.attributeName === this.ATTRIBUTES.DOCUMENT) {
          let locale = htmlElement.getAttribute(this.ATTRIBUTES.DOCUMENT);
          if (locale !== mutation.oldValue) {
            yield this.setLocale(locale, this.FALLBACK_CACHE);
            callback(locale);
          }
        }
      }));
    });
    ownerDocumentObserver.observe(htmlElement, { attributes: true });
  }
  /**
   * observeElementLocale
   * @param baseElement
   * @param callback
   */
  observeElementLocale(baseElement, callback) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => __async(this, null, function* () {
        if (mutation.attributeName === this.ATTRIBUTES.ELEMENT) {
          let locale = element.getAttribute(this.ATTRIBUTES.ELEMENT);
          if (locale !== mutation.oldValue) {
            yield this.setLocale(locale, this.FALLBACK_CACHE);
            callback(locale);
          }
        }
      }));
    });
    observer.observe(baseElement, { attributes: true });
  }
  /**
   * execute
   * @param locale
   * @param phrases
   */
  execute(locale, phrases) {
    return __async(this, null, function* () {
      let translationApi = new UtilTranslationApi(
        this.MACHINE,
        this.SYSTEM_ID
      );
      let translationsApiResponse = yield translationApi.execute(locale, phrases);
      return {
        language: locale,
        //@ts-ignore
        entries: translationsApiResponse
      };
    });
  }
  /**
   * isNode
   */
  isNode() {
    return typeof process !== "undefined" && !!process.versions && !!process.versions.node;
  }
};
/**
 * not found sign
 */
_UtilI18N.PHRASE_NOT_FOUND_SIGN = "\xB0";
/**
 * ENVIRONMENT_DEFAULT
 * @private
 */
_UtilI18N.ENVIRONMENT_DEFAULT = {
  DIA_I18N_MACHINE: "NO_MACHINE_DEFINED",
  DIA_I18N_SYSTEM_ID: "RSP"
};
var UtilI18N = _UtilI18N;

// src/index.ts
var src_default = UtilI18N;
export {
  src_default as default
};
